import * as React from 'react';
import { useSelector } from 'react-redux';
import { Publication } from './Publication';
import { selectIsSubagentLimitExceed, selectPublishTermsStatus } from '../../selectors/publishTerms';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../selectors/publishAvailable';
import { EPublishTermsStatus } from '../../types/reducers/publishTerms';
import { selectIsPublicationWrapperVisible } from '../../selectors/elementsVisibility';

export const PublicationContainer = () => {
  const status = useSelector(selectPublishTermsStatus);
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);
  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);
  const isPublicationWrapperVisible = useSelector(selectIsPublicationWrapperVisible);

  const isInitial = status === EPublishTermsStatus.initial;
  const isLoading = status === EPublishTermsStatus.pending;
  const isError = status === EPublishTermsStatus.fail;

  if (isInitial || isIdentificationNeeded || isPublishToHiddenBase || !isPublicationWrapperVisible) {
    return null;
  }

  return (
    <div data-testid="publication">
      <Publication isLoading={isLoading} isError={isError} isSubagentLimitExceed={isSubagentLimitExceed} />
    </div>
  );
};
